export enum MessageSeverity {
  Success = 'success',
  Info = 'info',
  Warning = 'warn',
  Error = 'error',
}
